import React from 'react';
import { Link, Outlet } from 'react-router-dom';

const LaTertulia = () => {
  return (
    <div className="container">
      <nav>
     
      </nav>
      <Outlet />
    </div>
  );
}

export default LaTertulia;
